if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);

    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';

			if ( this.querySelector('button') ) {
	      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
			}
    }

    renderPreview(sectionInnerHTML) {
      const pickupInformation = sectionInnerHTML.querySelector('.pickup-availability-information');
      if (!pickupInformation) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = pickupInformation.outerHTML;
      this.setAttribute('available', '');

      const sidePanel = document.getElementById('Pickup-Availability');
      const sidePanelContent = sectionInnerHTML.querySelector('.side-availability');
      if (sidePanel) {
        sidePanel.innerHTML = sidePanelContent ? sidePanelContent.innerHTML : '';
      }

      const button = this.querySelector('.pickup-availability-toggle-button');
      if (button) button.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!sidePanel) return;
        sidePanel.classList.add('active');
        document.body.classList.add('open-cc');
      });
    }
  });
}
